import ironManImg from '../assets/images/iron-man.png';
import spiderManIgm from '../assets/images/spider-man.png';
import thorImg from '../assets/images/thor.png';
import hulkImg from '../assets/images/hulk.png';
import wolverineImg from '../assets/images/wolverine.png';
import captainAmericaImg from '../assets/images/captain-america.png';

export const listOfCreators = [
  'Federico Blee',
  'Sebastian Carrillo',
  'John Tyler Christopher',
  'Christina Harrington',
  'Vc Cory Petit',
  'Mariko Tamaki',
  'Tom Brevoort',
  'C Cafu',
  'Christopher Cantwell',
  'Vc Joe Caramagna',
  "Frank D'ARMATA",
  'Alex Ross',
  'Henry Abrams',
  'J.J Abrams',
  'Olivier Coipel',
  'Nick Lowe',
  'Sara Pichelli',
  'Dave Stewart',
];

export const characters = [
  { id: 1, name: 'iron man', image: ironManImg },
  { id: 2, name: 'spider-man', image: spiderManIgm },
  { id: 3, name: 'thor', image: thorImg },
  { id: 4, name: 'hulk', image: hulkImg },
  { id: 5, name: 'wolverine', image: wolverineImg },
  { id: 7, name: 'captain america', image: captainAmericaImg },
];
